import { Component, OnInit, SimpleChanges } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of, switchMap, tap } from 'rxjs';
import { DataLayer } from 'src/app/shared/models/node';
import { SelectModel } from 'src/app/shared/models/search.model';
import { NavigationService } from 'src/app/shared/services/navigation.service';
import { NodeService } from 'src/app/shared/services/node.services';
import { TYPE_OF_CONTENT } from 'src/assets/data/type_of_content';
import { HelpersService } from 'src/app/shared/services/helpers.service';


@Component({
  selector: 'app-search-page',
  templateUrl: './search-page.component.html',
  styleUrls: ['./search-page.component.scss']
})
export class SearchPageComponent implements OnInit {

  private currentLang: string = '';
  public searchResult: any[] = [];
  public searchValue: FormControl = new FormControl();
  public counterPage: number = 0;
  // SELECT
  public checkboxGroupForm: FormGroup;
  public checkArray!: Observable<any>;
  public titleDropdown: string = '';
  public isValue: boolean = false;
  public data_tipi_contenuto: any = TYPE_OF_CONTENT;
  private selectedValue: string = '';
  public itemLength: number = 0;
  public viewMore = false;
  public window: any;
  public wait = true;
  public clickOnCTA = false;

  get ordersFormArray() {
    return this.checkboxGroupForm.controls['checkbox'] as FormArray;
  }


  constructor(
    public nodeService: NodeService,
    public helpersService: HelpersService,
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    public navigationService: NavigationService,
    private translate: TranslateService
  ) {
    this.checkboxGroupForm = this.formBuilder.group({
      checkbox: new FormArray([])
    });
  }

  ngOnInit(): void {
    this.helpersService.nodeType = "pagina";
    this.nodeService.setTitle(`${this.translate.instant("SEARCH_BAR.SEARCH")} | Università di Roma LUMSA`);
    this.sortContentTypes()
    this.helpersService.onChangeLang.subscribe((lang: any) => {
      this.currentLang = lang.split('-')[0];
      this.sortContentTypes();
    });
    this.window = this.nodeService.getWindow();
    this.currentLang = this.nodeService.lang.split('-')[0];
    this.wait = true;
    this.activatedRoute.queryParams.pipe(
      tap(query => this.searchValue.setValue(query['text'])),
      switchMap(query => this.nodeService.getSearch(this.currentLang, `text=${query['text']}`))
    ).subscribe(result => {
      this.searchResult = result.rows;
      this.wait = false;
      this.isMoreContent(result.pager);
      this.setDataLayer();
    }, err => {      
      this.wait = false;
    });
    this.initSelect();
  }

  sortContentTypes() {    
    this.data_tipi_contenuto.value.sort((a: any, b: any) => {
      const aValue = this.translate.instant(a.value);
      const bValue = this.translate.instant(b.value);
      if (aValue < bValue) {
        return -1;
      }
      if (aValue > bValue) {
        return 1;
      }
      return 0;
    });
  }

  public setTitle(item: any): any {
    return this.nodeService.retriveLinkTagA(item.field_titolo, 'a');
  }

  public search(clickOnCTA = false): void {
    this.clickOnCTA = clickOnCTA;
    this.wait = true;
    this.counterPage = 0;
    let valueSearch = this.selectedValue 
    valueSearch = this.selectedValue !== '' ? `text=${this.searchValue?.value ?? ""}&${this.selectedValue}` : `text=${this.searchValue?.value ?? ""}`;
    // this.firstTime = false;
    this.nodeService.getSearch(this.currentLang, valueSearch).subscribe(result => {
      this.searchResult = result.rows;
      this.isMoreContent(result.pager);
      this.setDataLayer();
      this.wait = false;
    }, err => {
      this.wait = false;
    });
  }

  public addContentResult(): void {
    //     if (!this.clickOnCTA) {
    let value = this.searchValue.value;
    if (!this.clickOnCTA) { 
      value = this.searchValue.value ? this.searchValue.value : window.location.href.split('=')[1];
    }
    value = value ? value : "";
    let valueSearch = this.selectedValue;
    valueSearch = this.selectedValue !== '' ? `text=${value}&${this.selectedValue}` : `text=${value}`;
    this.nodeService.getSearch(this.currentLang, valueSearch, this.counterPage).subscribe(res => {
      this.searchResult = [
        ...this.searchResult,
        ...res.rows
      ];
      this.isMoreContent(res.pager);
    });
  }

  private isMoreContent(pager: any): void {
    if (((pager.current_page + 1) * pager.items_per_page) < Number(pager.total_items) ) {
      this.viewMore = true;
    } else {
      this.viewMore = false;
    }
    if ((this.counterPage <= pager.total_pages - 1)) {
      this.counterPage += 1;
    }
  }

  // Select
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['resetValueCheckbox']) {
      this.checkboxGroupForm.reset();
      this.isValue = false;
      this.titleDropdown = this.data_tipi_contenuto.titolo;
    }
  }

  private initSelect(): void {
    this.addCheckboxes();
    this.titleDropdown = this.data_tipi_contenuto.titolo;
    this.checkArray = of(this.data_tipi_contenuto.value);
  }

  private addCheckboxes(): void {
    this.data_tipi_contenuto.value.forEach(() => this.ordersFormArray.push(new FormControl(false)));
  }

  private setTitleDropdown(selectedCheckbox: SelectModel[]): void {
    if (selectedCheckbox.length === 1) {
      this.isValue = true;
      this.itemLength = 0;
      this.titleDropdown = selectedCheckbox[0].value;
    } else if (selectedCheckbox.length > 1) {
      this.isValue = true;
      this.itemLength = selectedCheckbox.length;
      this.titleDropdown = `${this.data_tipi_contenuto.titoloMulti}`
    } else {
      this.isValue = false;
      this.titleDropdown = this.data_tipi_contenuto.titolo;
    }
  }

  public submitSelect(): void {
    let selValue: string = '';
    const value = this.checkboxGroupForm.value.checkbox.map((checked: any, i: any) => checked ? this.data_tipi_contenuto.value[i] : null).filter((v: null) => v !== null);
    value.map((el: SelectModel, idx: number) => {
      if (idx < value.length - 1) {
        selValue += `content-type%5B%5D=${el.content_type}&`;
      } else {
        selValue += `content-type%5B%5D=${el.content_type}`;
      }
    })
    this.selectedValue = selValue;
    this.setTitleDropdown(value);
  }

  public setDataLayer() {
    const dataLayer: DataLayer = {
      event: 'Search',
      location: this.window.frames.location.origin,
      pagePath: this.window.frames.location.pathname,
      TypeSearch: 'Portal',
      query: this.searchValue.value
    }
    this.window.dataLayer = this.window.dataLayer || [];
    this.window.dataLayer.push(dataLayer);
  }

  public resetValue(){
    this.titleDropdown = this.data_tipi_contenuto.titolo;
    this.checkboxGroupForm.reset();
    this.searchValue.reset();
    this.selectedValue = "";
    this.itemLength = 0;
  }

}
